import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=1b036f6f&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=1b036f6f&prod&lang=scss&scoped=true"
import style1 from "./Button.vue?vue&type=style&index=1&id=1b036f6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b036f6f",
  null
  
)

export default component.exports